import { RxapDataSource } from 'eurogard-data-source';
import { Injectable, inject, signal } from '@angular/core';
import { NotificationAccordionControllerGetByIdResponse } from 'open-api-service-feature-user/responses/notification-accordion-controller-get-by-id.response';
import { NotificationAccordionControllerGetByIdRemoteMethod } from 'open-api-service-feature-user/remote-methods/notification-accordion-controller-get-by-id.remote-method';
import { AccordionDataSource } from 'eurogard-data-source/accordion';
import { NotificationAccordionControllerGetByIdParameter } from 'open-api-service-feature-user/parameters/notification-accordion-controller-get-by-id.parameter';
import { OpenApiRemoteMethodParameter } from 'eurogard-open-api-remote-method';
import { ActivatedRoute } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';
import { from } from 'rxjs';
import { UserControllerMeGUIRemoteMethod } from 'open-api-legacy/remote-methods/user-controller-me-gui.remote-method';
import { UserControllerMeGUIResponse } from 'open-api-legacy/responses/user-controller-me-gui.response';

@Injectable()
@RxapDataSource('user-settings-accordion')
export class UserSettingsAccordionDataSource extends AccordionDataSource<NotificationAccordionControllerGetByIdResponse, OpenApiRemoteMethodParameter<NotificationAccordionControllerGetByIdParameter, void>> {
  protected readonly route = inject(ActivatedRoute);
  protected override readonly method = inject(NotificationAccordionControllerGetByIdRemoteMethod);
  private readonly getCurrentUser = inject(UserControllerMeGUIRemoteMethod);
  public readonly user = signal<UserControllerMeGUIResponse | undefined>(undefined);

  getParameters() {
    return from(this.getCurrentUser.call()).pipe(
      take(1),
      tap(user => this.user.set(user)),
      map(user => ({ parameters: { uuid: user.uuid ?? '' } }))
    );
  }

  override async refresh(): Promise<void> {
    const user = await this.getCurrentUser.call();
    this.user.set(user);
    return super.refresh();
  }
}
